<main class="page-container__body">
    <div class="container-fluid">
        <div class="body_area">
            <div class="page-header">
                <h1>Remove your account</h1>
                <hr class="hr-highlight" />
            </div>
            <div class="d-flex justify-content-center">
                <div class="col-md-4 page-border">
                    <div class="d-flex justify-content-center">
                        <p for="removeAccount">Your bidder account is&nbsp;</p>
                        <label for="removeAccount">{{username}}</label>
                    </div>
                    <p>All your data will be erased. Please be careful before removing your account, this action can't be undone.</p>
                    <div class="form-group">
                        <button [disabled]="isLoading" class="btn btn-danger btn-lg btn-block" (click)="onRemovePressed()">
                            <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
                            Remove
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
